import { Link } from "react-router-dom";

const HotelCsvNav = ({ selected, str }) => {
  const array = [
    {
      id: "csv",
      name: "Generate Reports",
    },

    {
      id: "changes",
      name: "Pending Changes",
    },
  ];

  return (
    <nav style={{ marginTop: "0px" }}>
      {array.map((item) => {
        return (
          <Link
            key={item.id}
            className={
              item.id === selected ? "subpage-tab selected" : "subpage-tab"
            }
            to={
              item.id === "csv"
                ? `/hotelcsv/${str}`
                : `/hotelcsv/${item.id}/${str}`
            }
          >
            {item.name}
          </Link>
        );
      })}
    </nav>
  );
};

export default HotelCsvNav;
